import PropTypes from 'prop-types'
import styled from 'styled-components'

import { color } from 'styles/colors'

const propTypes = {
  variant: PropTypes.oneOf([
    'primaryButton', 'secondaryButton', 'tertiaryButton', 'destructiveButton', 'semiDestructiveButton', 'cell', 'page'
  ]).isRequired
}

const Spinner = (props) => <S.Spinner role="alert" aria-busy="true" aria-live="polite" {...props} />

Spinner.propTypes = propTypes

export default Spinner

const spinnerColor = (variant) => {
  switch (variant) {
    case 'primaryButton':
    case 'destructiveButton':
    case 'semiDestructiveButton':
      return color('primaryButtonSpinner')
    case 'secondaryButton':
    case 'tertiaryButton':
    case 'cell':
      return color('secondaryButtonSpinner')
    case 'page':
      return color('pageSpinner')
    default: throw new Error(`Unexpected spinner variant: ${variant}`)
  }
}

const margin = ({ variant }) => {
  switch (variant) {
    case 'cell':
      return '0'
    case 'page':
      return '9em auto'
    default:
      return '-2px auto -16px'
  }
}

const S = {
  Spinner: styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'variant'
  })`
    width:  ${({ variant }) => variant === 'page' ? '50px' : '15px'};
    height: ${({ variant }) => variant === 'page' ? '50px' : '15px'};
    margin: ${margin};
    border-radius: ${({ variant }) => variant === 'page' ? '25px' : '9px'};
    border: solid ${({ variant }) => variant === 'page' ? '3px' : '2px'} transparent;
    border-top-color: ${({ variant }) => spinnerColor(variant)};
    border-left-color: ${({ variant }) => spinnerColor(variant)};
    -webkit-animation: nprogress-spinner 600ms linear infinite;
    -moz-animation:    nprogress-spinner 600ms linear infinite;
    -ms-animation:     nprogress-spinner 600ms linear infinite;
    -o-animation:      nprogress-spinner 600ms linear infinite;
    animation:         nprogress-spinner 600ms linear infinite;

    @-webkit-keyframes nprogress-spinner {
      0%   { -webkit-transform: rotate(0deg);   transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
    }
    @-moz-keyframes nprogress-spinner {
      0%   { -moz-transform: rotate(0deg);   transform: rotate(0deg); }
      100% { -moz-transform: rotate(360deg); transform: rotate(360deg); }
    }
    @-o-keyframes nprogress-spinner {
      0%   { -o-transform: rotate(0deg);   transform: rotate(0deg); }
      100% { -o-transform: rotate(360deg); transform: rotate(360deg); }
    }
    @-ms-keyframes nprogress-spinner {
      0%   { -ms-transform: rotate(0deg);   transform: rotate(0deg); }
      100% { -ms-transform: rotate(360deg); transform: rotate(360deg); }
    }
    @keyframes nprogress-spinner {
      0%   { transform: rotate(0deg);   transform: rotate(0deg); }
      100% { transform: rotate(360deg); transform: rotate(360deg); }
    }
  `
}
